import { AxiosInstance } from 'axios';
import { SimpleSettingsRepository } from '@/model/repository/shift/SimpleSettingsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): SimpleSettingsRepository => ({
    index() {
      return Repository.get(`${resource}`, { data: { errorHandle: false } });
    },
    update(payload) {
      return Repository.put(`${resource}`, payload);
    },
  });
